import { ToolbarButton, ToolbarButtonGroup } from 'neon-design-system';
import { RequestType } from '../../constants/request';

interface Props {
  type: RequestType;
  setRequestType: (type: RequestType) => void;
}

export const ToolbarRequestTypeButtonGroup = ({ type, setRequestType }: Props) => {
  return (
    <ToolbarButtonGroup isFirstElement>
      <ToolbarButton text="My requests" id="myRequests" selected={type === RequestType.MY_REQUESTS} onClick={() => setRequestType(RequestType.MY_REQUESTS)} />
      <ToolbarButton text="All" id="all" selected={type === RequestType.ALL} onClick={() => setRequestType(RequestType.ALL)} />
    </ToolbarButtonGroup>
  );
};
